var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"uploadImage"},on:{"click":_vm.clickFile}},[_c('img',{staticClass:"hideimg",attrs:{"src":require("../../assets/pic.png"),"alt":""}}),_vm._v(" "),_c('input',{ref:"imgDom",staticClass:"hide",attrs:{"type":"file"},on:{"change":_vm.pictureChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437f5bc7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upLoadImage/index.vue
// module id = null
// module chunks = 